import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, combineLatest } from 'rxjs';

import { SubscriptionPlan, SubscriptionsDetails } from '@vi-iot/client';

import { BookingStore, DocumentsStore } from '@store';
import { ViToastService } from '@vi-iot/ui/index';
import { TranslateService } from '@ngx-translate/core';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-flat-booking-summary',
  templateUrl: './flat-booking-summary.component.html',
  styleUrls: ['./flat-booking-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlatBookingSummaryComponent implements OnInit, OnDestroy {
  @Output() continue = new EventEmitter<void>();

  BookingPlans = SubscriptionPlan;
  tosAccepted = false;
  subscriptionsDetails: SubscriptionsDetails;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public bookingStore: BookingStore,
    public documentsStore: DocumentsStore,
    public toastService: ViToastService,
    public translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.documentsStore.getDocuments();
    combineLatest(
      this.bookingStore.subscriptionsDetails$,
      this.bookingStore.subscriptionsDetailsLoaded$
    )
      .pipe(
        filter(([_subscriptionsDetails, loaded]) => loaded),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe(([subscriptionsDetails]) => {
        if (subscriptionsDetails) {
          this.subscriptionsDetails = subscriptionsDetails;
        } else {
          this.subscriptionsDetails = null;
          this.toastService.error({
            message: this.translateService.instant('+BOOKING.CHECKOUT.ERROR.PRICES_NOT_GET'),
          });
        }
      });
  }

  onContinue(): void {
    this.continue.emit();
  }

  onTosCheckboxChange(isTosAccepted: boolean): void {
    this.tosAccepted = isTosAccepted;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
    this.bookingStore.resetSubscriptionsDetails();
  }
}
